<template>
    <div class="main">

        <div class="main-content">

            <!-- 精选组合 -->
            <choiceness></choiceness>

            <!-- 听单分类 -->
            <!-- <listen-classify></listen-classify> -->

            <div class="height8 bgF5F5F5"></div>

            <!-- 听书榜单 -->
            <voiceCourseTopList></voiceCourseTopList>

            <div class="height8 bgF5F5F5"></div>

            <!-- 最近更新 -->
            <recent-changes></recent-changes>
        </div>

        <!-- 回到顶部 -->
        <!-- <div class="back-top">
                <div class="top-icon">
                    <a href="javaScript:;" @click="goToTop()">
                        <img class="relative" src="icon/learnIcon/huidaodingbu.svg"
                             alt="回到顶部图标" style="top: 1px;margin-right:4px;">
                        <span>回到顶部</span>
                     </a>

                </div>

        </div> -->
    </div>
</template>
<script>
// 最近更新模块
import recentChanges    from './listenComp/recentChanges'
//精选组合模块
import choiceness       from './listenComp/choiceness'
//听单分类模块
import listenClassify   from './listenComp/listenClassify'
//往期榜单模块
import voiceCourseTopList      from './listenComp/voiceCourseTopList'

// part
import generalCmpPart   from '@comp/part/generalCmpPart';

// util
import windowHelper from '@util/windowHelper';

export default {
    name: "listen",
    extends : generalCmpPart,

    data(){
        return {
            isShow:true
        }
    },
     components: {
         recentChanges,
         choiceness,
         listenClassify,
         voiceCourseTopList
    },

    methods:{

        goToTop() {
            windowHelper.scrollTo();
        }

    }
}
</script>
<style scoped lang="scss">
    //.main{
    //    background: #f6f6f6;
    //}

    .sum-nav{
        width: 100%;
        height: 35px;
        // box-sizing: border-box;
        overflow-x: auto;
        background: #fff;
        // padding: 16px 0;
        padding-bottom: 16px;
        padding-top: 5px;
        .nav-list{
            // width: 650px;
            // height: 22px;
            margin-left:18px;
            .nav-item{
            // width: 100px;
            height:100%;
            float: left;
            margin-right: 20px;

            font-size: 12px;

            font-weight: 400;
            line-height: 32px;
            color: #646F84;

            }

            .active{
                padding: 5px 16px;
                background: #FDF4E7;

                border-radius: 14px;

                font-size: 12px;

                font-weight: 500;
                line-height: 20px;
                color: #FFA724;
            }

        }




    }






    // 搜索框
    .search{
        width: 100%;
        height: 28px;
        // margin-bottom: 16px;
        padding-bottom: 8px;
        background: #fff;

         .search-content{
            width: 94%;
            height: 28px;
            margin: 0 auto;
            position: relative;
            box-sizing: border-box;
            background: #f6f6f6;
            border: 0;
            border-radius: 14px;
        div{
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -75px;
            width: 150px;
            height: 100%;
            line-height: 28px;
            color: #acacac;
           .search-icon{
               position: absolute;
               top: 9px;
               left: 9px;
               width: 12px;
               height: 12px;
           }
           span{
               position: absolute;
               top: 0;
               left: 25px;

                font-size: 12px;

                font-weight: 400;
                color: #ACACAC;

           }
        }


    }


    }

    //回到顶部
.back-top{
    display: flex;
    background: #F6F6F6;
    width: 100%;
    height: 94px;
    .top-icon{
        margin: auto;
        width: 135px;
        height: 26px;

        line-height: 26px;
        text-align: center;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        a{
            font-size: 14px;

            font-weight: 400;
            color: #CDCDCD;


        }
    }
}
</style>
